import AppIcon from '../icons/AppIcon'
import styles from './GateScreen.module.css'

interface GateChallengeCardProps {
  title: string
  description: string
  imageUrl?: string
  showReplay?: boolean
  onReplay?: () => void
}

function withBold(description: string) {
  return description.split('**').map((part, index) =>
    index % 2 === 1 ? <strong key={index}>{part}</strong> : part,
  )
}

export default function GateChallengeCard({
  title,
  description,
  imageUrl,
  showReplay,
  onReplay,
}: GateChallengeCardProps) {
  return (
    <div
      className={[styles.challenge, imageUrl && styles.challengeImage].filter(Boolean).join(' ')}
      data-testid="gate-challenge-card"
      {...(imageUrl ? { 'data-gate-image': imageUrl } : {})}
      style={imageUrl ? { backgroundImage: `url("${imageUrl}")` } : undefined}
    >
      <div className={styles.chTop}>
        <div className={styles.chEyebrow}>Team Challenge</div>
        {showReplay && onReplay && (
          <button type="button" className={styles.chReplay} onClick={onReplay}>
            <AppIcon icon="mdi:play" size={14} />
            Replay
          </button>
        )}
      </div>
      <div className={styles.chTitle}>{title}</div>
      <p className={styles.chDesc}>{withBold(description)}</p>
    </div>
  )
}
